/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@material-ui/core';

export interface IFormikRadioOption {
    disabled?: boolean;
    value?: any;
    label?: string;
}

const FormikRadio = ({ field: { ...fields }, form: { touched, errors }, ...props }): React.ReactNode => {
    const { id, label, options, variant, icon, checkedIcon, fullWidth, ...rest } = props;
    const error = Boolean(_.get(touched, fields.name) && _.get(errors, fields.name));

    return (
        <FormControl error={error} variant={variant} id={id} fullWidth={fullWidth}>
            {label && <FormLabel>{label}</FormLabel>}
            <RadioGroup className="custom-radio-group" {...fields} {...rest}>
                {options &&
                    options.map((option: IFormikRadioOption) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            label={option.label}
                            control={
                                <Radio
                                    disabled={option.disabled}
                                    className="custom-radio"
                                    checkedIcon={checkedIcon}
                                    icon={icon}
                                />
                            }
                            disabled={props?.disabled}
                        />
                    ))}
            </RadioGroup>
            {error && <FormHelperText error>{error && errors[fields.name]}</FormHelperText>}
        </FormControl>
    );
};
export default FormikRadio;
